const initSpinner = () => {
  const btnPhotoSubmits = document.querySelectorAll('#btn-photo-submit');
  if (btnPhotoSubmits) {
    btnPhotoSubmits.forEach((btnPhotoSubmit) => {
      btnPhotoSubmit.addEventListener('click', (event) => {
        const photoContainers = document.querySelectorAll(".photo-container");
        photoContainers.forEach((photoContainer) => {
          photoContainer.innerHTML =
            `<div class="lds-roller">
              <div>
              </div>
              <div>
              </div>
              <div>
              </div>
              <div>
              </div>
              <div>
              </div>
              <div>
              </div>
              <div>
              </div>
              <div>
              </div>
            </div>`;
        })
      })
    })
  }
}

export { initSpinner };
